import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { esApiError } from './api/http';
import { AuthRaiz } from './auth/AuthRaiz';
import { App } from './App';
import { ErrorRecarga, instalarRecargaPorVersion } from './components/ErrorRecarga';
import { PortalDiferido } from './portal/PortalDiferido';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/poppins/latin-600.css';
import './styles/base.css';
import './styles/contenido.css';
import './styles/app.css';
import './styles/espacio.css';
import './styles/v2.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Los errores 4xx son definitivos (permiso, validación, no encontrado): no se reintentan.
      retry: (intentos, error) => !(esApiError(error) && error.status >= 400 && error.status < 500) && intentos < 2,
    },
    mutations: { retry: false },
  },
});

// Portal externo de Personas (§15.9): fuera de AuthRaiz (sin Entra ID ni MSAL) y sin el Layout interno. En la
// demostración estática (enrutamiento por hash) la ruta llega como #/portal.
const esPortal = window.location.pathname.startsWith('/portal') || /^#\/?portal/.test(window.location.hash);

instalarRecargaPorVersion();

const aplicacion = (
  <AuthRaiz>
    <App />
  </AuthRaiz>
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorRecarga>
      <QueryClientProvider client={queryClient}>
        {esPortal ? (
          <PortalDiferido />
        ) : import.meta.env.VITE_DEMO ? (
          /* La demostración estática se sirve desde cualquier subruta y sin reescritura: enrutamiento por hash. */
          <HashRouter>{aplicacion}</HashRouter>
        ) : (
          <BrowserRouter>{aplicacion}</BrowserRouter>
        )}
      </QueryClientProvider>
    </ErrorRecarga>
  </StrictMode>,
);
